import React from "react";
import { Link } from "react-router-dom";
import moment from "moment/moment";

export default function VoteList({ index, display_account, create_time }) {
    const date = moment
        .utc(create_time, ["YYYY-MM-DD HH:mm:ss", "DD[/]MM[/]YYYY HH:mm:ss"])
        .utcOffset("+0700")
        .format("DD[/]MM[/]YYYY HH:mm:ss");

  return (
    <React.Fragment>
      <tr>
        <td>{index}</td>
        <td>{display_account}</td>
        <td>{date}</td>
      </tr>
    </React.Fragment>
  );
}
